export default "__VITE_ASSET__UenZyeFO__"